module.exports = __webpack_public_path__ + "static/media/SL_24_ADDON.66844cf1.mp3";